// extracted by mini-css-extract-plugin
export var colorSquare = "_m9-0";
export var danger = "_m9-5";
export var lightPink = "_m9-8";
export var neutralBlue = "_m9-7";
export var neutralYellow = "_m9-6";
export var normal = "_m9-1";
export var primary = "_m9-2";
export var primaryLight = "_m9-3";
export var solidBlack = "_m9-g";
export var solidGreen = "_m9-b";
export var solidLightBlue = "_m9-d";
export var solidNavy = "_m9-c";
export var solidOrange = "_m9-f";
export var solidPink = "_m9-e";
export var solidRed = "_m9-9";
export var solidYellow = "_m9-a";
export var success = "_m9-4";